import * as React from 'react';

import './styles/header.css';

export const HeaderText = ({text, color}) => {
    return (
        <h2 className='header-text' style={{color}}>{text}</h2>
    )
}